import { Fetch } from '../fetch/fetch-service';

export function fetchCommittees() {
  return Fetch('/idp-auth/pbasen/admin/Committees');
}

export function fetchCommittee(guid) {
  return Fetch(`/idp-auth/pbasen/admin/Committees?id=${guid}`);
}

export function postModifyCommittee(guid, committee) {
  return Fetch(`/idp-auth/pbasen/admin/Committee?id=${guid}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(committee),
  });
}

export function postModifyMembersInCommittee(guid, committee = []) {
  return Fetch(`/idp-auth/pbasen/admin/AddUsersToCommittee?id=${guid}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(committee),
  });
}

export function postActivateCommittee(guid, status) {
  const jsonbody = JSON.stringify({
    active: status,
  });
  return Fetch(`/idp-auth/pbasen/admin/Committee?id=${guid}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: jsonbody,
  });
}

export function fetchCommitteesUsers() {
  return Fetch('/idp-auth/pbasen/admin/Users');
}

export function putCommittee(committee = {}) {
  return Fetch('/idp-auth/pbasen/admin/Committee', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name: committee.name,
      'esa-id': committee.esaId,
      code: committee.shortCode,
      index: committee.index,
      active: committee.active,
    }),
  });
}

export function postRemoveCommittee(id) {
  return Fetch(`/idp-auth/pbasen/admin/RemoveCommittee?id=${id}`, {
    method: 'POST',
    headers: {},
  });
}

export function fetchCommitteeNames() {
  return Fetch('/idp-auth/pbasen/admin/CommitteeNames');
}

export function fetchCommitteeHistory(id, from, to) {
  return Fetch(`/idp-auth/pbasen/admin/CommitteeHistory?id=${id}&from=${from}&to=${to}`);
}
